import { WidgetGridItem } from "./WidgetGridItem";

interface WidgetStackProps {
    activeWidgets: string[];
    isCustomizing: boolean;
    onRemoveWidget: (widgetId: string) => void;
}

export function WidgetStack({ activeWidgets, isCustomizing, onRemoveWidget }: WidgetStackProps) {
    return (
        <div className="flex flex-col gap-2">
            {activeWidgets.map((widgetId) => (
                <WidgetGridItem
                    key={widgetId}
                    widgetId={widgetId}
                    isCustomizing={isCustomizing}
                    onRemove={onRemoveWidget}
                    fill={false}
                />
            ))}
        </div>
    );
}
